export const GLOBAL_NOTIFICATION = {
  UPDATED_SUCCESSFULLY: "Successfully Updated",
  DELETED_SUCCESSFULLY: "Successfully Deleted",
  CREATED_SUCCESSFULLY: "Successfully Created",
  APPROVED_SUCCESSFULLY: "Successfully Approved",
  SOMETHING_WENT_WRONG: "Something went wrong",
  NO_DATA_FOUND: "No data found",
  UNEXPECTED_ERROR: "Unexpected Error",
  INVALID_DATA: "Invalid Data",
  INVALID_FORM: "Invalid format Errors",
};

export const EMPTY_FILE_TITLE = "File is empty";
export const EMPTY_FILE_MESSAGE =
  "The selected file is empty. Check the file content and upload a different file.";

export const MAX_LENGTH = 4000;
export const MAX_LENGTH_SUPPORT_TEXT = 80;
export const MAX_LENGTH_SKU_NAME = 64;
export const MAX_LENGTH_HTML = 8000;
export const RETURN_REASON_MAX_LENGTH = 2000;
export const VALIDATION_ERROR_MESSAGES = {
  REQUIRED: "This field is required",
  INVALID_EMAIL: "Invalid Email",
  INVALID_PHONE: "Invalid Phone Number",
  INVALID_NUMBER: "Invalid Number",
  INVALID_DATE: "Invalid Date",
  INVALID_URL: "Invalid URL",
  INVALID_PASSWORD: "Invalid Password",
  INVALID_CONFIRM_PASSWORD: "Password and Confirm Password should be same",
  EMAIL_FORMAT_ERROR: "Please enter a valid email",
  NUMBER_FORMAT_ERROR: "Please enter a valid number",
  INTEGER_FORMAT_ERROR: "Please enter a valid integer number",
  MAX_LENGTH_ERROR: `Maximum length should be ${MAX_LENGTH} characters`,
  MAX_LENGTH_HTML_ERROR: `Maximum length should be ${MAX_LENGTH_HTML} characters`,
  OPPORTUNITY_CODE_ERROR: `Please provide a valid Opportunity ID`,
  ENGAGEMENT_CODE_ERROR: `Please provide a valid Engagement Code`,
  NOT_ZERO_ERROR: `Minimum Selectable Increment must be at least 1`,
  PERCENTAGE_RANGE_ERROR: `Indexation must be between 0.00 to 100.00`,
  MINIMUM_SELECT_INCREMENT_INT_NUM: `Please enter a positive whole number (at least 1). Decimals and negative values are not permitted.`,
  INVALID_CHARACTERS: `Invalid Characters`,
};

export const customPaginationPageSize: number = 10;
export const customPaginationPageSizeSelector: number[] = [10, 20, 50];

export const TIMEOUT_LIMIT_FOR_SESSION_MESSAGE = 3540000; // 59 minutes
export const TIMEOUT_LIMIT_FOR_SESSION_POPUP = 120000; // 2 minutes

export const SESSSIION_TIMEOUT_MESSAGE = {
  TITLE: "Still with us?",
  MESSAGE:
    "Privacy is essential, and you have been gone a while. You will be logout in 2 min unless you confirm you are still with us.",
  BUTTON_TEXT_CANCEL: "Cancel",
  BUTTON_TEXT_LOGOUT: "Log Out",
  BUTTON_TEXT_CONTINUE: "Continue working",
};

export const AUTH_SYNC_LOCAL_STORAGE_KEY = "authSync";
export const EXPLICIT_LOGOUT_LOCAL_STORAGE_KEY = "explicitLogout";
export const SESSION_CONTINUE_LOCAL_STORAGE_KEY = "sessionContinue";
export const SESSION_LOGOUT_LOCAL_STORAGE_KEY = "sessionLogout";
export const SESSION_LOGOUT_COMPLETE_LOCAL_STORAGE_KEY = "sessionLogoutComplete";
export const SESSION_CONTINUE_EVENT = "sessionContinue";
export const TOKEN_REFRESH_SYNC_LOCAL_STORAGE_KEY = "tokenRefreshSync";
export const TOKEN_REFRESH_LOCK_NAME = "commercialhub-token-refresh";
export const TOKEN_REFRESH_LOCK_LOCAL_STORAGE_KEY = "tokenRefreshLock";
export const TOKEN_REFRESH_LOCK_TIMEOUT = 30000;

export const CANCEL_BUTTON_TEXT = "Cancel";
export const NO_DRAFT_ESTIMATE_HEADING = "No estimates or drafts created yet";
export const NO_ESTIMATE_TEXT = `It looks like you do not have any estimates created yet. Please browse
          our technology products to start creating estimates.`;
export const NO_DRAFT_TEXT = `It looks like you do not have any drafts created yet. Please browse
          our technology products to start creating drafts.`;
export const ESTIMATE = "Estimates";

export const NO_ORDERS_HEADING = "No orders created yet";
export const NO_ORDERS_TEXT = `It looks like you do not have any orders created yet. Please browse
          our technology products to start creating orders.`;
export const NO_APPROVALS_HEADING = "No orders to approve";
export const NO_APPROVALS_TEXT =
  "You have no orders waiting for your approval.";

export const NO_CANCELLED_ORDERS_HEADING = "No cancelled orders yet";
export const NO_CANCELLED_ORDERS_TEXT = `It looks like you do not have any cancelled orders yet.`;
export const NO_RETURN_ORDERS_HEADING = "No return orders yet";
export const NO_RETURN_ORDERS_TEXT = `It looks like you do not have any return orders yet.`;
export const ORDER = "Orders";
export const RETURNS = "Returns";
export const CANCELLED_ORDERS = "Cancelled Orders";
export const APPROVALS = "Approvals";

export const ORDER_ACKNOWLEDGEMENT = "Order acknowledgment";
export const GLOBAL_RISK_MANAGER = "Global Risk Manager";
export const GLOBAL_RISK_MANAGER_FIELD = "global_risk_manager";
export const LOCAL_RISK_MANAGER = "Local Risk Manager";
export const PRODUCT_APPROVER = "Product Approver";
export const PROVISIONING_TEAM = "Provisioning Team";
export const NO_DRAFTS_CREATED_YET = "No drafts created yet";
export const NO_ESTIMATES_CREATED_YET = "No estimates created yet";
export const CONSUMPTION_MANAGER = "Consumption Manager";

// Order Recoveries
export const RECOVERIES = "Recoveries";
export const TOTAL_BILLED = "Total Billed";
export const NO_DRAFT_RECOVERY_HEADING = "No recoveries yet";
export const NO_RECOVERIES_CREATED_YET = "No recoveries created yet";
export const NO_RECOVERY_TEXT = `It looks like you do not have any recovered orders yet.`;

//Transactions
export const TRANSACTIONS = "Auto Transact";
export const NO_TRANSACTIONS_HEADING = "No transactions yet";
export const NO_TRANSACTIONS_TEXT = `It looks like you do not have any transacted orders yet.`;
export const TOTAL_BILLED_TOOLTIP =
  "The Total Billed displays the sum of all the filtered Auto Transactions.";
export const TRANSACTION_ID_TOOLTIP_TITLE = "Auto Transaction Status";

//Max Values
export const MAX_QUANTITY = 999999;
export const MAX_DURATION_MONTHS = 120;
export const MAX_DURATION_WEEKS = 521;

// Product Detail
export const OVERVIEW = "Overview";
export const PRODUCT_SKUS_INFORMATION = "Product SKUs Information";
export const MORE_INFORMATION = "More Information";
export const CONTACTS = "Contacts";

export const FORM_LABEL_DESCRIPTION = {
  CT_PORTFOLIO:
    "A Portfolio is defined as a managed grouping or collective investments which cater to a given Service Line or function. When used within Solutions, it refers to the collective of programs and projects for a given Service Line or function.",
  PRODUCT_DESCRIPTION:
    "Explains what the product is and does while providing details of the product’s purpose, features, and benefits.",
  COMMERCIAL_DESCRIPTION:
    "Explains how technology is ordered, priced, and deployed. Outlines how to access the product, SKUs, subscriptions, licenses, and what commercial terms apply.",
  MORE_INFORMATION:
    "Centers on the why and what to consider. Offers advice on how to use the product effectively, tactical considerations, warnings, integration options, and sales tips.",
};
export const SKU_DRAFT_OPTIONAL_FIELDS = [
  "skuLongDescription",
  "costCategory",
  "chargingIncrement",
  "returnable",
  "costMacroCategory",
  "minimumSelectableIncrement",
  "cost",
  "autoProvision",
  "commercialStatus",
  "billingType",
  "costMetric",
  "Indexation",
];

export const COST_MACRO_CATEGORY = "Types of Cost Included";
export const AI_SMART_SEARCH_LINK_TITLE =
  "Did you find what you were looking for?";
export const AI_SMART_SEARCH_LINK_PRODUCT_CARD_DESC = `We will add more products here soon. For now, to find more EY products and contact information try`;
export const AI_SMART_SEARCH_LINK_BANNER_DESC1 =
  "We will add more products here soon.";
export const AI_SMART_SEARCH_LINK_BANNER_DESC = `For now, to find more EY products and contact information try`;
export const AI_SMART_SEARCH = "AI Smart Search";
export const AI_SMART_SEARCH_LINK =
  "AI Smart Search: Revolution your product discovery experience";
export const AI_SMART_SEARCH_LINK_DESC = `Did you find what you were looking for? If not, we will
                      add more products to our marketplace soon. For now, to
                      find more products and associated contact information, try
                      AI Smart Search.`;
export const RETIRED_SKU_IN_CHECKOUT_MESSAGE = `SKUs in your order has been retired. Please remove it from your order to continue!`;
export const VIEW_CHECKOUT_WARNING =
  "You currently have view only access to this estimate. To modify the estimate contact the owner:";
export const EMOJI_ERROR_MESSAGE = "We are not allowing Emojis on search";
export const ERROR_RETRIVING_DATA =
  "An error has occurred while attempting to retrieve the data. \n Click the button to retry.";
export const TRY_AGAIN = "Try Again";
export const NO_DATA_FOR_SKU =
  "There is currently no data available for this SKU";
export const EMOJI_ERROR_MESSAGE_CREATE = "We are not allowing Emojis";
export const NO_ACCESS_ESTIMATE = "No access to estimate.";
export const NO_ACCESS_ESTIMATE_SUGGESTION = `You currently don’t have permission to view this estimate.`;
export const NO_ACCESS_ESTIMATE_SUGGESTION2 = `Please contact the estimate owner to get access.`;
export const ESTIMATE_NAME = "Estimate Name: ";
export const ESTIMATE_ID = "Estimate ID: ";
export const OWNER = "Owner: ";
export const DELETE_ESTIMATE = "The estimate does not exist";
export const DELETED_ESTIMATE_SUGGESTION = `This estimate does not exist or has been deleted.`;
export const DELETED_ESTIMATE_SUGGESTION2 = `If your estimate has been deleted,`;
export const DELETED_ESTIMATE_SUGGESTION3 = `please contact the estimate owner for more information.`;
export const RICH_TEXT_EDITOR_FIELD_NAMES = [
  "skuLongDescription",
  "commercialDescription",
  "assetAdvice",
];
export const REQUIRED_COST_METRICS_AVIALBLE =
  "Select a Cost Type to view available Cost Metrics";

export const RESOURCES = "Resources";
export const SKU_NAME_HELPER_TEXT =
  "The SKU name has a limit of 64 characters.";
export const SOMTHING_WENT_WRONG = "Something went wrong. Please try again.";
export const DELETE_DOCUMENT_CONFIRMATION_MASSAGE =
  "Are you sure you want to delete this product resource? This action cannot be undone.";
export const CONSUMPTION_CSV_UPLOAD_ERROR_MESSAGE = `There was an error when attempting to upload your file. Please reference the "Instructions" section in the downloaded file to ensure you followed the guidelines correctly. Once you have verified that the instructions were followed, please try uploading the file again.`;
export const ORDER_EXTENSION = "Order Extension";
export const SKU_EXTENSION = "SKU Extension";
export const SKU_EXTENSION_HELPER_TEXT = `Extend duration of a SKU by adding additional periods for an active order`;
export const ORDER_EXTENSION_HELPER_TEXT = `Extend duration of SKUs by adding additional periods for an active order`;
export const WAF_ERROR_MESSAGE =
  "The request is blocked by the Web Application Firewall.";
export const SKU_EXTENSION_PLACED_TITLE = "SKU extension placed! Thank you";
export const SKU_EXTENSION_PLACED_DESCRIPTION =
  "Your SKU extension request has been successfully submitted. Please find the details below.";
export const ORDER_EXTENSION_PLACED_TITLE = "Order extension placed! Thank you";
export const ORDER_EXTENSION_PLACED_DESCRIPTION =
  "Your order extension request has been successfully submitted. Please find the details below.";
export const SEARCH_TIMER = 350; // in milliseconds
export const OPPORTUNITY_CODE_LOCAL_STORAGE_KEY = "opportunityCode";
export const ADMIN_PAGE_NO_ACCESS = {
  HEADER: "No admin access",
  DESCRIPTION: "You currently do not have permission to access admin modules.",
  SUGGESTION: "Please contact support to request access.",
  BUTTON_LABEL: "Go back to homepage",
};
export const ADMIN_CT_BM_NO_ACCESS = {
  HEADER: "No CT Business Management access",
  DESCRIPTION:
    "You currently do not have permission to access CT Business Management modules.",
  SUGGESTION: "Please contact support to request access.",
  BUTTON_LABEL: "Go back to homepage",
};
export const PAGE_NO_ACCESS = {
  HEADER: "Access required.",
  DESCRIPTION: "You currently do not have permission to access this page.",
  SUGGESTION: "Please contact support to request access.",
  BUTTON_LABEL: "Go back to homepage",
};
export const NO_ACCESS_CONSUMPTION = "Access required.";
export const NO_ACCESS_CONSUMPTION_SUGGESTION = `You don’t have permission to view the consumption page.`;
export const NO_ACCESS_CONSUMPTION_SUGGESTION2 = `Please contact the commercial owner.`;
export const IN_APPROVAL_STATUS = "In Approval";

//Billing-links
export const BILLING_PREVIEW_LINK =
  "https://fabric.ey.com/explore/eydx/content/68900aaf-2f1e-423b-8a2b-68e8f221fe09";
